import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { useFormContext, Controller } from 'react-hook-form'
const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

export const AutoCompleteWithService = ({ source, setInputValue, options }) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={source}
      defaultValue={[]}
      render={({ field }) => (
        <Autocomplete
          {...field}
          multiple
          id='checkboxes-tags-demo'
          options={options}
          Autocomplete
          disableCloseOnSelect
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(_, data) => field.onChange(data)}
          getOptionLabel={(option) => option.long_name}
          onInputChange={(_, newInputValue) => {
            setInputValue(newInputValue)
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
              {option.long_name}
            </li>
          )}
          style={{ width: 500 }}
          renderInput={(params) => <TextField {...params} placeholder='Buscar...' />}
        />
      )}
    />
  )
}
